import React from 'react'
import { PhoneFilled } from '@ant-design/icons'
import { Header } from 'antd/es/layout/layout'
import { useNavigate } from 'react-router'
import SearchXS from '../Search/SearchXS'

export default function PublicHeaderXS ({ styles, phoneNumber, phoneHref }) {
  const navigate = useNavigate()

  const AssistanceHeader = () => {
    return (
      <div style={styles.smallAssistanceText}>
        <div style={styles.assistancePhone}>
          <PhoneFilled /><a style={{ color: 'white' }} href={phoneHref}>{phoneNumber}</a>
        </div>
      </div>
    )
  }

  return (<>
    <Header className={'header'} style={styles.header}>
      <img onClick={() => navigate('/')} style={styles.logo} className="logo" src="/images/logo-lbm-blanc.svg" alt='Logo' width="200px" />
      <AssistanceHeader />
    </Header>
    <SearchXS />
  </>
  )
}
